import axios, { AxiosResponse } from "axios";

import { HEDGE_FUND_SERVER_URL, Ociswap_baseurl, networkRPC } from "Constants/endpoints";
import { dispatch, store } from "Store";
import { setStakingTokensPrices } from "Store/Reducers/app";
import {
  setBotWallet,
  setFelixWallet,
  setFomoBalance,
  setHitBalance,
  setReddicksBalance,
  setUserWallet,
  setxusdcBalance,
  updateHitFomoData,
} from "Store/Reducers/session";
import {
  setIsOwner,
  setLockedHITRewards,
  setLockedNodeStakingFomos,
  setLockedNodeStakingHits,
  setLockedNodeStakingREDDICKS,
  setLockedNodeStakingxUSDCs,
  setNodeStakeNFTid,
  setStHitBalance,
  setStHitTotalSupply,
  setStakedHIT,
} from "Store/Reducers/staking";
import { StakingTokens, Tabs } from "Types/reducers";
import { FungibleBalances, NonFungibleBalances, TokenData } from "Types/token";
import { BN, extractBalances, extractBalancesNew } from "./format";
import { EntityDetails, HedgeFundProtocolsDetailsResponse, MorpherPriceData } from "Types/api";
import {
  NODE_STAKING_USER_BADGE_ADDRESS,
  NODE_STAKING_FOMO_KEY_VALUE_STORE_ADDRESS,
  NODE_STAKING_HIT_KEY_VALUE_STORE_ADDRESS,
  POOL_ADDRESS,
  RUG_PROOF_STAKING_COMPONENT_ADDRESS,
  STHIT_RESOURCE_ADDRESS,
  HIT_RESOURCE_ADDRESS,
  FOMO_RESOURCE_ADDRESS,
  NODE_STAKING_COMPONENT_ADDRESS,
  FELIX_WALLET_ADDRESS,
  XUSDC_RESOURCE_ADDRESS,
  NODE_STAKING_XUSDC_KEY_VALUE_STORE_ADDRESS,
  REDDICKS_RESOURCE_ADDRESS,
  NODE_STAKING_REDDICKS_KEY_VALUE_STORE_ADDRESS,
  HEDGE_FUND_BOT_ADDRESS,
} from "Constants/address";
import {
  setRugProofComponentDataLoading,
  setNodeStakingRewardsLoading,
  setPoolDataLoading,
  setStHitDataLoading,
  setTokenDataLoading,
  setNodeStakingComponentDataLoading,
  setBotBalanceLoading,
} from "Store/Reducers/loadings";
import CachedService from "Classes/cachedService";
import {
  FungibleResourcesCollectionItem,
  NonFungibleResourcesCollectionItem,
  StateEntityFungiblesPageResponse,
  StateEntityNonFungiblesPageResponse,
} from "@radixdlt/babylon-gateway-api-sdk";

export const fetchBalances = async (walletAddress: string) => {
  let HITbalance = "0";
  let stHITbalance = "0";
  let fomobalance = "0";
  let reddicksBalance = "0";
  let xUSDCbalance = "0";
  // let xUSDTbalance = "0";
  let isOwner = false;
  let nftId: number | undefined = undefined;

  if (walletAddress) {
    try {
      const allFungibleItems = await fetchAllFungibles(walletAddress);
      const allNonFungibleItems = await fetchAllNonFungibles(walletAddress);

      // Collect all NFT ids from NODE_STAKING_USER_BADGE_ADDRESS
      const nftCandidates: number[] = [];
      allNonFungibleItems.forEach((nonfungItem) => {
        if (
          nonfungItem.aggregation_level === "Vault" &&
          nonfungItem.resource_address === NODE_STAKING_USER_BADGE_ADDRESS
        ) {
          const items = nonfungItem.vaults.items[0].items;
          if (items && items.length > 0) {
            items.forEach((nft) => {
              const parsed = Number(nft.replace(/#/g, ""));
              if (!Number.isNaN(parsed)) {
                nftCandidates.push(parsed);
              }
            });
          }
        }
      });
      if (nftCandidates.length > 0) {
        nftId = Math.min(...nftCandidates);
      }

      const { balances, isOwner: isOwnerFound } = extractBalancesNew(
        allFungibleItems,
        [
          { symbol: StakingTokens.HIT, address: HIT_RESOURCE_ADDRESS },
          { symbol: StakingTokens.StHIT, address: STHIT_RESOURCE_ADDRESS },
          { symbol: StakingTokens.FOMO, address: FOMO_RESOURCE_ADDRESS },
          { symbol: StakingTokens.XUSDC, address: XUSDC_RESOURCE_ADDRESS },
          { symbol: StakingTokens.REDDICKS, address: REDDICKS_RESOURCE_ADDRESS },
          // { symbol: StakingTokens.XUSDT, address: XUSDT_RESOURCE_ADDRESS },
        ],
        true
      );
      HITbalance = balances[StakingTokens.HIT];
      stHITbalance = balances[StakingTokens.StHIT];
      fomobalance = balances[StakingTokens.FOMO];
      xUSDCbalance = balances[StakingTokens.XUSDC];
      reddicksBalance = balances[StakingTokens.REDDICKS];
      // xUSDTbalance = balances[StakingTokens.XUSDT];
      isOwner = isOwnerFound;
    } catch (error) {
      console.log("error in fetchBalances", error);
    }
  }
  store.dispatch(setNodeStakeNFTid(nftId));
  store.dispatch(setHitBalance(HITbalance));
  store.dispatch(setStHitBalance(stHITbalance));
  store.dispatch(setFomoBalance(fomobalance));
  store.dispatch(setReddicksBalance(reddicksBalance));
  // store.dispatch(setxusdtBalance(xUSDTbalance));
  store.dispatch(setxusdcBalance(xUSDCbalance));
  store.dispatch(setIsOwner(isOwner));
};

const fetchAllFungibles = async (walletAddress: string) => {
  let allFungibleItems: FungibleResourcesCollectionItem[] = [];
  let nextCursor = undefined;
  let response: StateEntityFungiblesPageResponse;
  let state_version: number | undefined = undefined;
  do {
    response = await CachedService.gatewayApi.state.innerClient.entityFungiblesPage({
      stateEntityFungiblesPageRequest: {
        address: walletAddress,
        cursor: nextCursor,
        aggregation_level: "Global",
        at_ledger_state: state_version ? { state_version } : undefined,
      },
    });

    allFungibleItems = allFungibleItems.concat(response.items);
    nextCursor = response.next_cursor;
    state_version = response.ledger_state.state_version;
  } while (nextCursor);
  return allFungibleItems;
};

const fetchAllNonFungibles = async (walletAddress: string) => {
  let allNonFungibleItems: NonFungibleResourcesCollectionItem[] = [];
  let nextCursor = undefined;
  let response: StateEntityNonFungiblesPageResponse;
  let state_version: number | undefined = undefined;
  do {
    response = await CachedService.gatewayApi.state.innerClient.entityNonFungiblesPage({
      stateEntityNonFungiblesPageRequest: {
        address: walletAddress,
        cursor: nextCursor,
        aggregation_level: "Vault",
        opt_ins: { non_fungible_include_nfids: true },
        at_ledger_state: state_version ? { state_version } : undefined,
      },
    });
    allNonFungibleItems = allNonFungibleItems.concat(response.items);
    nextCursor = response.next_cursor;
    state_version = response.ledger_state.state_version;
  } while (nextCursor);
  return allNonFungibleItems;
};

export const getSelectedBalance = () => {
  const state = store.getState();
  const {
    staking: { currentTab, stHitBalance },
    session: { hitBalance },
  } = state;
  return currentTab === Tabs.stake ? BN(hitBalance) : BN(stHitBalance);
};

export const fetchHitFomoData = async () => {
  let hitPrice: number | undefined = undefined;
  let fomoPrice: number | undefined = undefined;
  let reddicksPrice: number | undefined = undefined;
  let hitData: TokenData | undefined = undefined;
  let fomoData: TokenData | undefined = undefined;
  let reddicksData: TokenData | undefined = undefined;
  try {
    store.dispatch(setTokenDataLoading(true));

    // Use Promise.all to fetch both tokens data simultaneously
    const [hitDataResponse, fomoDataResponse, reddicksDataResponse] = await Promise.all([
      axios.get<any, AxiosResponse<TokenData>>(`${Ociswap_baseurl}/tokens/${HIT_RESOURCE_ADDRESS}`),
      axios.get<any, AxiosResponse<TokenData>>(
        `${Ociswap_baseurl}/tokens/${FOMO_RESOURCE_ADDRESS}`
      ),
      axios.get<any, AxiosResponse<TokenData>>(
        `${Ociswap_baseurl}/tokens/${REDDICKS_RESOURCE_ADDRESS}`
      ),
    ]);

    // Handle HIT token response
    if (hitDataResponse.status === 200) {
      hitPrice = +hitDataResponse.data.price.usd.now;
      hitData = hitDataResponse.data;
    } else {
      console.error("Failed to fetch HIT token data", hitDataResponse.status);
    }

    // Handle FOMO token response
    if (fomoDataResponse.status === 200) {
      fomoPrice = +fomoDataResponse.data.price.usd.now;
      fomoData = fomoDataResponse.data;
    } else {
      console.error("Failed to fetch FOMO token data", fomoDataResponse.status);
    }
    // Handle REDDICKS token response
    if (reddicksDataResponse.status === 200) {
      reddicksPrice = +reddicksDataResponse.data.price.usd.now;
      reddicksData = reddicksDataResponse.data;
    } else {
      console.error("Failed to fetch REDDICKS token data", reddicksDataResponse.status);
    }
  } catch (error) {
    console.error("Error fetching token data", error);
  } finally {
    store.dispatch(
      setStakingTokensPrices({ hit: hitPrice, fomo: fomoPrice, reddicks: reddicksPrice })
    );
    store.dispatch(updateHitFomoData({ hit: hitData, fomo: fomoData, reddicks: reddicksData }));
    store.dispatch(setTokenDataLoading(false));
  }
};

export const fetchStHITTotalSupply = async () => {
  let totalSupply = "0";
  try {
    store.dispatch(setStHitDataLoading(true));
    const response = await axios.post<any, AxiosResponse<EntityDetails>>(
      `${networkRPC}/state/entity/details`,
      {
        addresses: [STHIT_RESOURCE_ADDRESS],
      }
    );

    if (response.status === 200) {
      totalSupply = response.data.items[0].details.total_supply;
    }
  } catch (error) {
    console.log("error in fetchStHITTotalSupply", error);
  }
  store.dispatch(setStHitTotalSupply(totalSupply));
  store.dispatch(setStHitDataLoading(false));
};

export const fetchPoolDetails = async () => {
  let stakedHIT = "0";
  try {
    store.dispatch(setPoolDataLoading(true));
    const response = await axios.post<any, AxiosResponse<EntityDetails>>(
      `${networkRPC}/state/entity/details`,
      {
        addresses: [POOL_ADDRESS],
      }
    );

    if (response.status === 200) {
      const { balances } = extractBalances(response.data.items[0].fungible_resources.items, [
        { symbol: StakingTokens.HIT, address: HIT_RESOURCE_ADDRESS },
      ]);
      stakedHIT = balances[StakingTokens.HIT];
    }
  } catch (error) {
    console.log("error in fetchPoolDetails", error);
  }
  store.dispatch(setStakedHIT(stakedHIT));
  store.dispatch(setPoolDataLoading(false));
};

export const fetchRugProofComponentDetails = async () => {
  let lockedHITs = "0";
  try {
    store.dispatch(setRugProofComponentDataLoading(true));
    const response = await axios.post<any, AxiosResponse<EntityDetails>>(
      `${networkRPC}/state/entity/details`,
      {
        addresses: [RUG_PROOF_STAKING_COMPONENT_ADDRESS],
      }
    );

    if (response.status === 200) {
      const { balances } = extractBalances(response.data.items[0].fungible_resources.items, [
        { symbol: StakingTokens.HIT, address: HIT_RESOURCE_ADDRESS },
      ]);
      lockedHITs = balances[StakingTokens.HIT];
    }
  } catch (error) {
    console.log("error in fetchRugProofComponentDetails", error);
  }
  store.dispatch(setLockedHITRewards(lockedHITs));
  store.dispatch(setRugProofComponentDataLoading(false));
};

export const fetchNodeStakingComponentDetails = async () => {
  let totalHITs = "0";
  let totalFOMOs = "0";
  let totalXUSDCs = "0";
  let totalREDDICKS = "0";
  // let totalXUSDTs = "0";

  let assignedHITS = "0";
  let assignedFOMOs = "0";
  let assignedXUSDCs = "0";
  let assignedREDDICKs = "0";
  // let assignedXUSDTs = "0";
  try {
    store.dispatch(setNodeStakingComponentDataLoading(true));
    const response = await axios.post<any, AxiosResponse<EntityDetails>>(
      `${networkRPC}/state/entity/details`,
      {
        addresses: [NODE_STAKING_COMPONENT_ADDRESS],
      }
    );

    if (response.status === 200) {
      const { balances } = extractBalances(response.data.items[0].fungible_resources.items, [
        { symbol: StakingTokens.HIT, address: HIT_RESOURCE_ADDRESS },
        { symbol: StakingTokens.FOMO, address: FOMO_RESOURCE_ADDRESS },
        { symbol: StakingTokens.XUSDC, address: XUSDC_RESOURCE_ADDRESS },
        { symbol: StakingTokens.REDDICKS, address: REDDICKS_RESOURCE_ADDRESS },
        // { symbol: StakingTokens.XUSDT, address: XUSDT_RESOURCE_ADDRESS },
      ]);
      totalHITs = balances[StakingTokens.HIT];
      totalFOMOs = balances[StakingTokens.FOMO];
      totalXUSDCs = balances[StakingTokens.XUSDC];
      totalREDDICKS = balances[StakingTokens.REDDICKS];
      // totalXUSDTs = balances[StakingTokens.XUSDT];
      response.data.items[0].details.state.fields[2].entries.forEach((entry: any) => {
        switch (entry.key.value) {
          case HIT_RESOURCE_ADDRESS:
            assignedHITS = entry.value.fields[1].value;
            break;
          case FOMO_RESOURCE_ADDRESS:
            assignedFOMOs = entry.value.fields[1].value;
            break;
          case XUSDC_RESOURCE_ADDRESS:
            assignedXUSDCs = entry.value.fields[1].value;
            break;
          case REDDICKS_RESOURCE_ADDRESS:
            assignedREDDICKs = entry.value.fields[1].value;
            break;
          // case XUSDT_RESOURCE_ADDRESS:
          //   assignedXUSDTs = entry.value.fields[1].value;
        }
      });
    }
  } catch (error) {
    console.log("error in fetchNodeStakingComponentDetails", error);
  }
  store.dispatch(setLockedNodeStakingHits(BN(totalHITs).minus(assignedHITS).toString()));
  store.dispatch(setLockedNodeStakingFomos(BN(totalFOMOs).minus(assignedFOMOs).toString()));
  store.dispatch(setLockedNodeStakingxUSDCs(BN(totalXUSDCs).minus(assignedXUSDCs).toString()));
  store.dispatch(
    setLockedNodeStakingREDDICKS(BN(totalREDDICKS).minus(assignedREDDICKs).toString())
  );
  store.dispatch(setNodeStakingComponentDataLoading(false));
  // store.dispatch(setLockedNodeStakingxUSDTs(BN(totalXUSDTs).minus(assignedXUSDTs).toString()));
};

export const fetchClaimableNodeStakingRewards = async (nftId: number) => {
  const keyValueAddressesWithTheirTokens = [
    { address: NODE_STAKING_HIT_KEY_VALUE_STORE_ADDRESS, token: StakingTokens.HIT },
    { address: NODE_STAKING_FOMO_KEY_VALUE_STORE_ADDRESS, token: StakingTokens.FOMO },
    { address: NODE_STAKING_XUSDC_KEY_VALUE_STORE_ADDRESS, token: StakingTokens.XUSDC },
    { address: NODE_STAKING_REDDICKS_KEY_VALUE_STORE_ADDRESS, token: StakingTokens.REDDICKS },
  ];

  let claimableRewards = {
    HIT: "0",
    FOMO: "0",
    xUSDC: "0",
    REDDICKS: "0",
    // xUSDT: "0",
    // oldFOMO: "0"
  };

  try {
    store.dispatch(setNodeStakingRewardsLoading(true));
    const keyValueDataResponses = await Promise.all(
      keyValueAddressesWithTheirTokens.map((key_value_store_address) =>
        CachedService.gatewayApi.state.innerClient.keyValueStoreData({
          stateKeyValueStoreDataRequest: {
            key_value_store_address: key_value_store_address.address,
            keys: [{ key_json: { kind: "U64", value: nftId.toString() } }],
          },
        })
      )
    );
    keyValueDataResponses.forEach((response, index) => {
      if (
        response.entries.length > 0 &&
        response.entries[0].value.programmatic_json.kind === "Decimal"
      ) {
        claimableRewards[
          keyValueAddressesWithTheirTokens[index].token as keyof typeof claimableRewards
        ] = response.entries[0].value.programmatic_json.value;
      }
    });
  } catch (error) {
    console.log("unable to fetch ClaimableNodeStakingRewards:", error);
  }
  store.dispatch(setNodeStakingRewardsLoading(false));
  return claimableRewards;
};

export const fetchFelixWalletBalance = async () => {
  const balances = await fetchWalletBalance(FELIX_WALLET_ADDRESS);

  if (!balances) {
    console.log("error in fetchFelixWalletBalance");
    return false;
  }

  dispatch(
    setFelixWallet({
      fungible: balances.fungible,
      nonFungible: balances.nonFungible,
    })
  );
  return true;
};

export const fetchUserWalletBalance = async (walletAddress: string) => {
  const balances = await fetchWalletBalance(walletAddress);

  if (!balances) {
    console.log("error in fetchUserWalletBalance");
    return false;
  }

  dispatch(
    setUserWallet({
      fungible: balances.fungible,
      nonFungible: balances.nonFungible,
    })
  );
  return true;
};

export const fetchBotWalletBalance = async () => {
  dispatch(setBotBalanceLoading(true));
  const balances = await fetchWalletBalance(HEDGE_FUND_BOT_ADDRESS);

  if (!balances) {
    console.log("error in fetchBotWalletBalance");
    dispatch(setBotBalanceLoading(false));
    return false;
  }

  dispatch(
    setBotWallet({
      fungible: balances.fungible,
      nonFungible: balances.nonFungible,
    })
  );
  dispatch(setBotBalanceLoading(false));
  return true;
};

export const fetchWalletBalance = async (walletAddress: string) => {
  try {
    const [fungibleBalances, nonFungibleBalances] = await Promise.all([
      fetchAllFungibles(walletAddress),
      fetchAllNonFungibles(walletAddress),
    ]);

    let formattedFungibleBalances: FungibleBalances = {};
    fungibleBalances.forEach((balance) => {
      if (balance.aggregation_level === "Global") {
        const amount = balance.amount;
        const tokenAddress = balance.resource_address;
        if (+amount > 0) {
          formattedFungibleBalances[tokenAddress] = { tokenAddress, amount };
        }
      }
    });

    let formattedNonFungibleBalances: NonFungibleBalances = {};
    nonFungibleBalances.forEach((item) => {
      if (item.aggregation_level === "Vault") {
        const collectionAddress = item.resource_address;
        const ids = item.vaults.items[0].items;
        if (ids && ids.length > 0) {
          formattedNonFungibleBalances[collectionAddress] = { collectionAddress, ids };
        }
      }
    });

    return {
      fungible: formattedFungibleBalances,
      nonFungible: formattedNonFungibleBalances,
    };
  } catch (error) {
    console.log("error in fetchWalletBalance", error);
    return undefined;
  }
};

// Fetch price data using the signed oracle message
export const fetchPriceDataFromOracle = async () => {
  try {
    const response = await fetch(`${HEDGE_FUND_SERVER_URL}/common/test-oracle-price`);

    if (!response.ok) {
      throw new Error(`Oracle API error: ${JSON.stringify(await response.json())}`);
    }

    const priceData = (await response.json()) as MorpherPriceData;
    return priceData;
  } catch (error) {
    console.error("Error in fetchPriceDataFromOracle:", error);
    throw error;
  }
};

// Convenience wrapper to fetch and return formatted hedge fund data

export const getFormattedInvestmentsInfo = async () => {
  try {
    const response = await fetch(`${HEDGE_FUND_SERVER_URL}/common/hedge-fund-protocols-details`);

    if (!response.ok) {
      throw new Error(`Failed to fetch hedge fund details: ${response.statusText}`);
    }

    const fundDetailsRaw = (await response.json()) as HedgeFundProtocolsDetailsResponse;

    if (!fundDetailsRaw || !fundDetailsRaw.data || !fundDetailsRaw.success) {
      return undefined;
    }

    const rawFunds = fundDetailsRaw.data.fundsDetails ?? [];
    const fundsDetails = [...rawFunds].sort(
      (a, b) => parseFloat(b.value ?? "0") - parseFloat(a.value ?? "0")
    );

    return {
      fundsDetails,
      totalFunds: fundDetailsRaw.data.totalFunds ?? "0",
    };
  } catch (error) {
    console.error("Error in getFormattedInvestmentsInfo:", error);
    return undefined;
  }
};

export const resolveSecret = (secret?: string) =>
  secret ?? process.env.REACT_APP_HEDGE_FUND_ADMIN_SECRET ?? "";

export const assertSecret = (secret: string) => {
  const normalized = secret.trim();
  if (!normalized) {
    throw new Error("Admin secret is required for protocol metadata requests.");
  }
  return normalized;
};
